<template>
	<section>
		<compWrapper :title="$t('fbb.costmanage.base_info', { defaultValue: '基础信息' })" theme="primary">
			<compFormEdit v-if="type!=='query'" class="margin-layout" ref="formbase" :formdata="getBase" v-model="formData"></compFormEdit>
			<compFormQuery v-else class="margin-layout" :formdata="getBase" :value="formData"></compFormQuery>
			<vButtonGroup slot="footer">
				<vButton
					v-for="item in getStatusBtns"
					:key="item.name"
					@click="item.run"
					:theme="item.theme"
				>{{item.name}}</vButton>
			</vButtonGroup>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
// import { mapGetters } from 'vuex';
import { HttpCarrier, HttpSaveCarrier } from '@/service/basicdata';
import mixin from "./mixin";
export default {
	mixins: [mixin],
	data() {
		return {
			loading: false,
			type: this.$route.params.type,
			id: this.$route.query.id,
			formData: {
				active:1
			},

		};
	},
	created() {
		this.getDetail();
	},
	computed: {
		/**
		 * 根据状态显示不同按钮
		 */
		getStatusBtns() {
			const btn = [{
				name: this.$t('global.common.save', { defaultValue: "保存" }),
				theme: 'primary',
				show: this.type!=='query',
				run: this.save
			}, {
				name: this.$t('global.common.return', { defaultValue: "返回" }),
				theme: 'default',
				show: true,
				run: this.cancel
			}]
			return btn.filter(item => item.show);
		},

		getBase() {
			return [{
				label: this.$t('fbb.alloment.carrier_code', { defaultValue: '承运商代码' }),
				key: "carrierCode",
				query: this.type !== 'add'
			}, {
				label: this.$t('fbb.basicdata.carrier_service', { defaultValue: '承运商服务名称' }),
				key: "carrierName",
			},
			{
				label: this.$t('fbb.basicdata.carrier_active', { defaultValue: '启用状态' }),
				key: "active",
				tag: 'vSelect',
				options: this.getActives.slice(1)
			},
			{
				label: this.$t('global.common.notes', { defaultValue: '备注' }),
				key: "remark",
				tag: 'vTextarea',
				required: false,
			},
			];
		},
	},
	methods: {
		//获取计划单详情
		getDetail() {
			if (this.type === 'add') return;
			this.loading = true;
			HttpCarrier({ id: this.id }).then(res => {
				this.loading = false;
				const data=res.data || {}
				this.formData = {
					id:this.id,
					carrierCode:data.carrierCode,
					carrierName:data.carrierName,
					active:data.active,
					remark:data.remark,
				}
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},

		//更新单据数据
		async save() {
			const valid = await this.$refs.formbase.validate();
			if (!valid) return;
			this.loading = true;
			HttpSaveCarrier(this.formData).then(()=>{
				this.$store.commit('dictionary/clearStore','carrierServiceList')
				this.cancel();
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }));
			})
		},
		cancel() {
			this.$router.push({
				name: 'basicdataCarrier'
			})
		}
	}
};
</script>
